var registry = new Map();
var register = function(key, value) {
    registry.set(key, value);
};
function get(key, options) {
    if (!(options === null || options === void 0 ? void 0 : options.optional) && !registry.has(key)) {
        throw new Error('Key "'.concat(key, '" does not exist in the registry.'));
    }
    return registry.get(key);
}
var clear = function() {
    registry.clear();
};
var toObject = function() {
    return Object.fromEntries(registry);
};
export var Registry = {
    /**
     * Registers a value at the specified key in the registry.
     *
     * @param key The unique identifier with which the value can be retrieved.
     * @param value The value to store in the registry.
     */ register: register,
    /**
     * Retrieves the value at the specified key in the registry.
     *
     * @param key The unique identifier with which the value can be retrived.
     * @param options An optional object to customize the behavior of the function.
     * - `optional` If true, the function will return undefined instead of throwing an error if the key does not exist.
     * @returns The value stored at the specified key.
     * @throws An error if the key has never been registered in the registry.
     */ get: get,
    /**
     * Erases all the information stored in the registry.
     * Useful during tests to ensure tests independance.
     */ clear: clear,
    /**
     * @returns The content of the registry.
     */ toObject: toObject
};
export default Registry;

//# sourceMappingURL=Registry.js.map